import React, { useEffect, useState } from 'react';
import Sidebar from '../Components/Sidebar';
import Header from '../Components/Header';
import { useCategoryStore } from '../store/useCategoryStore';
import Loader from '../Components/loader/Loader';
import { useLocation, useNavigate } from 'react-router-dom';

export default function AddCategory() {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        isFeatured: false, // dropdown value stored as string
        images: null,
    });
    const navigate = useNavigate()
    const location = useLocation();
    const [item, setItem] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const { addCategory, loading, getCategoryById } = useCategoryStore()

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        // console.log(name, value, type, files, formData)
        if (type === 'file') {
            const file = files[0];
            if (file) {
                setFormData(prev => ({ ...prev, [name]: file }));
                setPreviewUrl(URL.createObjectURL(file));
            }
        } else {

            const newValue =
                name === "isFeatured" ? (value === "true" ? true : value === "false" ? false : "") : value;
            setFormData(prev => ({ ...prev, [name]: newValue }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Convert isFeatured string to boolean
        // console.log(formData)
        // const payload = {
        //     ...formData,
        //     isFeatured: formData.isFeatured === "true",
        // };
        // console.log("final", formData)
        try {
            await addCategory(formData, item)
            navigate("/categories")
        } catch (error) {
            console.log("error", error)
        }

    };

    const getDetailFunction = async (id) => {
        if (!id) {
            return
        }
        const res = await getCategoryById(id)
        setFormData({
            name: res?.name,
            description: res?.description,
            isFeatured: res?.isFeatured,
            images: res?.images
        })

        setPreviewUrl(res?.images)

    }


    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const id = params.get("id");
        if (id) {
            setItem(id)
            getDetailFunction(id)
        }
    }, [location.search])

    return (
        <div id="dashboard-root" 
      className="flex min-h-[1000px] w-full">
        {/* <!-- Sidebar --> */}
        <Sidebar />
        {/* <!-- Main Content --> */}
        <main id="main-content" className="flex-1 px-10 py-8">
          {/* <!-- Header --> */}
            <Loader loading={loading} />
            <Header title="Add New Category" />
            <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 p-8 bg-white">

                    {/* Category Name */}
                    <div>
                        <label>Category Name</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="w-full border rounded px-3 py-2"
                        />
                    </div>
<div>
                        <label>Status?</label>
                        <select
                            name="isFeatured"
                            value={formData.isFeatured}
                            onChange={handleChange}
                            className="w-full border rounded px-3 py-2"
                        >
                            <option value="">Select</option>
                            <option value={false}>In Active</option>
                            <option value={true}>Active</option>
                        </select>
                    </div>
                    {/* Description */}
                    <div>
                        <label>Description</label>
                        <textarea
                            name="description"
                            rows="3"
                            value={formData.description}
                            onChange={handleChange}
                            className="w-full border rounded px-3 py-2"
                        />
                    </div>

                    {/* Is Featured Dropdown */}
                    

                        {/* Image Upload */}
                        <div>
                            <label>Icon Image</label>
                            <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center cursor-pointer relative">
                                <i className="fa-solid fa-cloud-arrow-up text-gray-400 text-3xl mb-2"></i>
                                <p className="text-sm text-gray-500">Click or drag files to upload</p>
                                <input
                                    type="file"
                                    name="images"
                                    accept="image/*"
                                    onChange={handleChange}
                                    className="absolute inset-0 opacity-0 cursor-pointer"
                                />
                            </div>
                            {previewUrl && (
                                <img src={previewUrl} alt="Preview" className="mt-2 h-20" />
                            )}
                        </div>

                    {/* Submit Buttons */}
                    <div className="col-span-full flex justify-end space-x-3 mt-4">
                        <button type="button" className="px-4 py-2 border rounded"
                            onClick={() => navigate(-1)}
                        >
                            Cancel
                        </button>
                        <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded">
                            Add Category
                        </button>
                    </div>

                </div>
            </form>
               </main>
        </div>
    );
}
